<script>
    import { onMount } from 'svelte';
    
    import { Navbar, NavItem, NavLink, Nav } from 'sveltestrap';

    export let items;
    export let selectItem;
    export let current;

    let labels = [];
    onMount(() => {
        if(items) {
            
            labels = Object.keys(items);
        }

    })
    
</script>

<Navbar light color="light" >
    <Nav class="md-auto" pills>
        {#each labels as label}
        <NavItem><NavLink id={label} href="#" on:click={selectItem} active={current === label}>{items[label]}</NavLink></NavItem>
        {/each}
    </Nav>
</Navbar>